import React from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

import { MessageType } from "./Message";

function AudioMessage(props) {

  const showMessageTime = () => {
    return props.message.type !== MessageType.info;
  };

  const messageTimeClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  const messageBoxClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return s360ConfigService.config.autoFullScreen ? "s360-message-box-received-fs" : "s360-message-box-received";
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  const messageContainerClassName = () => {
    switch (props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  const messageBoxStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
        return {
          height: "105px",
          display: "flex",
          alignContent: "center",
          width: "50%",
          ...config?.customDesign?.audioMessageBoxSender
        };
      case MessageType.sent:
        return {
          height: "105px",
          display: "flex",
          alignContent: "center",
          width: "50%",
          ...config?.customDesign?.audioMessageBoxReceiver
        };
      default:
        return {};
    }
  };

  const messageTimeStyle = () => {
    let config = props.config;
    switch (props.message.type) {
      case MessageType.received:
      case MessageType.sent:
      case MessageType.info:
        return config?.customDesign?.audioMessageTime
      default:
        return {};
    }
  };

  return (
    <div className={messageContainerClassName()}>
      <div className={messageBoxClassName()} style={messageBoxStyle()}>
        <figure style={{ width: "100%", alignSelf: "center" }}>
          <audio
            style={{ width: "100%" }}
            controls
            src={props.message.message.text}
          >
            Your browser does not support the <code>audio</code> element.
          </audio>
        </figure>
      </div>
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {showMessageTime() && (
          <div
            className={messageTimeClassName()}
            style={messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  this?.props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        {/* <Retry {...props} /> */}
      </div>
    </div>
  );
}

export default AudioMessage;
